export const DEFAULT_TEXT = 'Loading'
export const DOT = '.'
export const ANIMATION_DURATION = 700
